import NewsFeed from "@/pages/home/components/NewsFeed";
import HotSidebar from "@/pages/home/components/HotSidebar";

export default function FeedSection() {
  return (
    <section id="feed" className="w-full bg-background-100 border-y border-background-200/70">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-14 md:py-20">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-4 md:gap-8">
          <div className="max-w-2xl">
            <div className="inline-flex items-center gap-2 text-xs md:text-sm font-medium text-accent-700 bg-accent-100 px-3 py-1 rounded-full">
              <i className="ri-radar-line"></i>
              <span>短讯流</span>
            </div>
            <h2 className="mt-4 font-heading text-2xl md:text-4xl font-bold tracking-tight text-foreground-950">
              短讯与热帖并行，信息量管够
            </h2>
            <p className="mt-3 text-sm md:text-base leading-relaxed text-foreground-600">
              左边是刚冒头的线索，右边是社区正在追的热榜。先看短讯再进讨论，
              基本就能摸清一件事的来龙去脉。
            </p>
          </div>
          <div className="hidden md:flex items-center gap-2 text-sm text-foreground-500">
            <i className="ri-signal-tower-line"></i>
            当前在线浏览 3,182 人
          </div>
        </div>

        <div className="mt-8 md:mt-12 grid grid-cols-1 lg:grid-cols-12 gap-5 md:gap-6">
          <div className="lg:col-span-8">
            <NewsFeed />
          </div>
          <div className="lg:col-span-4">
            <HotSidebar />
          </div>
        </div>
      </div>
    </section>
  );
}